import { apiClient } from './client';
import { isAnalyticsSuppressed } from '../lib/preview';

/** Finder telemetry only targets PostHog. */
export type AnalyticsDestination = 'posthog';

/**
 * Fire-and-forget analytics beacon; swallows errors. Suppressed only while
 * previewing an unpublished finder; once published, preview links still track.
 */
export async function trackAnalytics(
  event: string,
  data: Record<string, unknown> = {},
  destinations: AnalyticsDestination[] = [],
): Promise<void> {
  if (isAnalyticsSuppressed()) return;
  try {
    await apiClient.post('/finder/analytics/track', { event, data, destinations });
  } catch (err) {
    console.error('[analyticsService] trackAnalytics failed', { event, err });
  }
}
